/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        key: "tips",
        value: "一个页面只能有一个底部悬浮，底部悬浮会悬浮在页面底部",
        type: "tips"
    },
    {
        name: "底部悬浮",
        type: "module-name"
    },
    {
        key: "link_data",
        name: "图片链接",
        type: "bottom-float"
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
                key: "radius",
                name: "圆角",
                type: "text"
            },
            {
                key: "distance",
                name: "距离底部距离",
                type: "text"
            },
            {
                key: "margin",
                name: "左右两侧间距",
                type: "text"
            }
        ]
    }
];

export default config;